import React, { useEffect, useState, useRef, useContext } from "react";
import * as echarts from "echarts";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../..";

const CommunityKitchenTrendView = (props) => {
  const echartsDom2 = useRef(null);
  const { theme } = useContext(ThemeContext);
  const [chart, setChart] = useState(null);
  const { t } = useTranslation();

  // Aggregating "Kids" data based on provided keys
  const kidsTotal = Object.entries(props.dataval || {}).reduce((acc, [key, value]) => {
    if (key.includes("Children Male") || key.includes("Children Female")) {
      return acc + value;
    }
    return acc;
  }, 0);

  // // Defining values for each category
  // const menTotal = props.dataval?.Males || 0;
  // const womenTotal = props.dataval?.Females || 0;
  // const transgenderTotal = props.dataval?.Transgender || 0;

   // Aggregating "Males" data, including "Males Disabled"
   const menTotal = Object.entries(props.dataval || {}).reduce((acc, [key, value]) => {
    if (key.includes("Males") && !key.includes("Females") && !key.includes("Transgender")) {
      return acc + value;
    }
    if (key.includes("Males Disabled")) {  // Include Disabled males under Males
      return acc + value;
    }
    return acc;
  }, 0);

  // Aggregating "Females" data, including "Females Disabled", "Females Postnatal", "Females Pregnant"
  const womenTotal = Object.entries(props.dataval || {}).reduce((acc, [key, value]) => {
    if (key.includes("Females") && !key.includes("Transgender") && !key.includes("Males")) {
      return acc + value;
    }
    if (key.includes("Females Disabled") || key.includes("Females Postnatal") || key.includes("Females Pregnant")) {  // Include all Females subcategories
      return acc + value;
    }
    return acc;
  }, 0);

  // Aggregating "Transgender" data, including "Transgender Disabled"
  const transgenderTotal = Object.entries(props.dataval || {}).reduce((acc, [key, value]) => {
    if (key.includes("Transgender") && !key.includes("Females") && !key.includes("Males")) {
      return acc + value;
    }
    if (key.includes("Transgender Disabled")) {  // Include Disabled transgender under Transgender
      return acc + value;
    }
    return acc;
  }, 0);

  const getLegendColor = (theme) => (theme === "light" ? "#2B6591" : "#fff");

  const options = {
    tooltip: {
      trigger: "item",
      confine: true,
    },
    legend: {
      orient: "vertical",
      right: "0",
      top: "center",
      selectedMode: false,
      itemWidth: 10,
      itemHeight: 10,
      textStyle: {
        color: getLegendColor(theme),
        fontSize: 11,
      },
    },
    xAxis: {
      type: "category",
      data: ["Males", "Females", "Children", "Transgender"],
      axisLine: { lineStyle: { color: getLegendColor(theme) } },
      axisTick: { show: false },
      axisLabel: {
        show: false,
      },
      splitLine: { show: false },
    },
    yAxis: {
      type: "value",
      axisLine: { lineStyle: { color: getLegendColor(theme) } },
      splitLine: { show: false },
      min: 0,
    },
    series: [
      {
        name: "Males",
        data: [menTotal, 0, 0, 0],
        type: "bar",
        itemStyle: { color: theme === "light" ? "#59b3ff" : "#519EFE", barBorderRadius: [10, 10, 0, 0] },
        barWidth: "15", // Smaller width to reduce gaps
        barGap: "-100%",
      },
      {
        name: "Females",
        data: [0, womenTotal, 0, 0],
        type: "bar",
        itemStyle: { color: theme === "light" ? "#7fd5ff" : "#B981F6", barBorderRadius: [10, 10, 0, 0] },
        barWidth: "15",
        barGap: "-100%",
      },
      {
        name: "Children",
        data: [0, 0, kidsTotal, 0],
        type: "bar",
        itemStyle: { color: theme === "light" ? "#74c2f2" : "#E28771", barBorderRadius: [10, 10, 0, 0] },
        barWidth: "15",
        barGap: "-100%",
      },
      {
        name: "Transgender",
        data: [0, 0, 0, transgenderTotal],
        type: "bar",
        itemStyle: { color: theme === "light" ? "#092f5c" : "#D252AA", barBorderRadius: [10, 10, 0, 0] },
        barWidth: "15",
        barGap: "-100%",
      },
    ],
    grid: {
      left: "17%",
      bottom: "5%",
      top: "5%",
      right: "30%",
    },
    barCategoryGap: "20%",
  };

  useEffect(() => {
    const myChart = echarts.init(echartsDom2.current);
    myChart.setOption(options);

    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(echartsDom2.current);

    return () => {
      window.removeEventListener("resize", handleResize);
      resizeObserver.disconnect();
      myChart.dispose();
    };
  }, [props.dataval, t, theme]);

  return (
    <div className="card" style={{ width: "100%", height: "95%" }}>
      <div className="card-body" style={{ height: "100%" }}>
        <div className="card-title">
          {t("navlinklabels.communitykitchen")}
        </div>
        <div ref={echartsDom2} style={{ height: "100%", width: "100%" }} />
      </div>
    </div>
  );
};

export default CommunityKitchenTrendView;
